import {
  Card,
  CardBody,
  Dialog,
  DialogBody,
  DialogHeader,
  Input,
  Select,
  Option,
  Typography,
} from "@material-tailwind/react";

import { IoCloseCircle } from "react-icons/io5";
import { useMutation, useQuery } from "react-query";
import { apiDirect } from "../../services/apiService";
import ApiRoutes from "../../services/apiRoutes";
import { BankData } from "../../models/wallet/banks";
import DefaultLoading from "../common/DefaultLoading";
import ErrorLoadingState from "../common/buttons/ErrorLoadingState";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  MakeTransferForm,
  MakeTransferValidation,
} from "../../pages/wallet/transferValidation";
import { useForm } from "react-hook-form";
import ErrorParagraph from "../common/ErrorParagraph";
import { useTransferStore } from "../../store/wallet/transferStore";
import LoadingButton from "../common/buttons/LoadingButton";
import { Constant } from "../../constants";
import { handleErrorMessage } from "../../utility";
import axios from "axios";
import { BankVerificationResponse } from "../../models/wallet/bankVerification";

function MakeTransfer({
  open: openDialog,
  openPinDialog: openPinDialog,
  handleOpen,
  amount,
  name,
  setName,
}: {
  open: boolean;
  handleOpen: () => void;
  name: string | undefined;
  setName: React.Dispatch<React.SetStateAction<string | undefined>>;
  openPinDialog: () => void;
  amount: string | number | undefined;
}) {
  const { data, isLoading, error } = useQuery(`getBanks`, () =>
    apiDirect.get<BankData>(ApiRoutes.getBanks)
  );

  const goToPin = () => {
    handleOpen();
    openPinDialog();
    reset();
  };

  const verifyAccountMutation = useMutation(
    "PayStack Verification",
    (data: MakeTransferForm) =>
      axios.get<BankVerificationResponse>(ApiRoutes.verifyAccountPayStack, {
        baseURL: ApiRoutes.paystackBaseUrl,
        params: {
          account_number: data.accountNumber,
          bank_code: data.selectedBank,
        },
        headers: { Authorization: Constant.PAY_STACK_KEY },
      }),
    {
      onSuccess(data, variables) {
        useTransferStore.getState().updateFormValues(variables);
        setName(data.data.data.account_name);
        // requestOtp();
      },
      onError(error) {
        console.log(error);
        reset();
        handleErrorMessage(error, "unable to verify bank");
      },
    }
  );

  // const requestOtp = () => {
  //   const user = AuthService.user?.data;
  //   apiDirect.get(ApiRoutes.getWalletOtp, {
  //     params: {
  //       phoneNumber: user?.phoneNumber,
  //       email: user?.email,
  //       otpType: 0,
  //     },
  //   }),
  //     {
  //       onSuccess() {
  //         openPinDialog();
  //         toast.success("Otp requested successfully");
  //       },

  //       onError() {
  //         console.log(error);
  //         handleErrorMessage(error, "request Otp");
  //       },
  //     };
  // };

  const banks = data?.data.data;
  const {
    handleSubmit,
    register,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(MakeTransferValidation),
  });

  const onSubmit = (data: MakeTransferForm) => {
    console.log(data);

    verifyAccountMutation.mutate(data);
  };

  return (
    <Dialog
      placeholder={undefined}
      open={openDialog}
      handler={handleOpen}
      size="md"
    >
      <DialogHeader placeholder={undefined} className="block">
        <section className="flex justify-center">
          <Typography
            placeholder={undefined}
            className="font-semibold text-md mx-auto"
          >
            Make Transfer
          </Typography>
          <IoCloseCircle onClick={() => handleOpen()} />
        </section>
        <Typography
          placeholder={undefined}
          className=" text-lg font-medium text-center"
        >
          Make seamless transfer to your account
        </Typography>
      </DialogHeader>

      <DialogBody placeholder={undefined}>
        {isLoading ? (
          <DefaultLoading />
        ) : error ? (
          <ErrorLoadingState />
        ) : (
          <Card placeholder={undefined} className=" shadow-sm">
            <div className="bg-[#1D1F2C] p-4 rounded-xl relative overflow-hidden">
              <span className="absolute top-2 right-2 w-3 h-3 rounded-full bg-green-500"></span>
              <span className="absolute top-5 w-4 h-4 rounded-full bg-purple-500"></span>
              <span className="absolute bottom-8  w-6 h-6 rounded-full border border-yellow-500"></span>
              <span className="absolute top-20 -right-4 w-10 h-10 rounded-full border-4 border-green-500"></span>
              <span className="absolute top-8 right-8 w-4 h-4 rounded-full border-4 border-red-500"></span>
              <Card
                placeholder={undefined}
                className=" bg-transparent rounded-xl relative z-10 shadow-xl text-center"
              >
                <CardBody
                  placeholder={undefined}
                  className="bg-transparent top-0 px-4 rounded-xl  right-2  text-gray-200"
                >
                  <Typography placeholder={undefined} className="text-md pb-2 ">
                    Available balance
                  </Typography>
                  <Typography
                    placeholder={undefined}
                    className="text-3xl font-medium text-white"
                  >
                    {amount}
                  </Typography>
                </CardBody>
              </Card>
            </div>
            <form
              onSubmit={(event) => {
                event.preventDefault();
                if (name === undefined) {
                  handleSubmit(onSubmit)();
                  return;
                }
                goToPin();
              }}
            >
              {banks?.length != undefined || banks?.length == 0 ? (
                <div className="pt-4">
                  <Select
                    placeholder={undefined}
                    value={"Please Select bank"}
                    {...register("selectedBank")}
                    onChange={(value) => {
                      if (value) setValue("selectedBank", value);
                      setName(value);
                    }}
                    label="Select Bank"
                  >
                    {banks!
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((bank) => (
                        <Option key={bank.code} value={bank.code}>
                          {bank.name}
                        </Option>
                      ))}
                  </Select>
                </div>
              ) : (
                <></>
              )}
              {errors.selectedBank && (
                <ErrorParagraph message={errors.selectedBank.message!} />
              )}
              <div className="pt-4">
                <Input
                  crossOrigin={undefined}
                  label="Amount to transfer"
                  {...register("transferAmount")}
                  className=" bg-gray-900/5 "
                  onChange={() => setName(undefined)}
                />
              </div>
              {errors.transferAmount && (
                <ErrorParagraph message={errors.transferAmount.message!} />
              )}
              <div className="pt-4">
                <Input
                  crossOrigin={undefined}
                  label="Recipient's Account Number"
                  {...register("accountNumber")}
                  className="bg-gray-900/5 "
                  onChange={() => setName(undefined)}
                />
              </div>
              {errors.accountNumber && (
                <ErrorParagraph message={errors.accountNumber.message!} />
              )}
              {name && (
                <Typography
                  placeholder={undefined}
                  className="flex justify-end text-green-500"
                >
                  {name}
                </Typography>
              )}
              <div className="py-6">
                <LoadingButton isLoading={verifyAccountMutation.isLoading}>
                  {name === undefined ? "Verify Account" : "Continue"}
                </LoadingButton>
              </div>
            </form>
          </Card>
        )}
      </DialogBody>
    </Dialog>
  );
}

export default MakeTransfer;
